import ExcelJS from 'exceljs';

/**
 * Configuración de la tabla según su tipo
 */
export function setUpTable(table_type) {
    switch (table_type) {
        case "sell":
            return {
                headers: ["SKU", "Nombre", "Precio"],
                gridTemplate: "0.8fr 3fr 1fr 120px",
                actions: { add: true, clone: true }
            }
        case "buy":
            return {
                headers: ["SKU", "Nombre", "Costo"],
                gridTemplate: "0.8fr 3fr 1fr 120px",
                actions: { add: true, clone: true }
            }
        case "stock":
            return {
                headers: ["SKU", "Nombre", "Precio", "Costo", "Stock", "Garantía", "Impuestos", "Activo"],
                gridTemplate: "1fr 2fr 1fr 1fr 1fr 1.2fr 1.2fr 80px 80px",
                actions: { edit: true },
                style: { maxHeight: 'calc(100vh - 350px)' }
            }
        default:
            return {
                headers: [],
                gridTemplate: "1fr",
                actions: {}
            };
    }
}

/**
 * Lógica de exportación a Excel para productos
 */
export async function handleExportExcel(inventario, type) {
    if (!Array.isArray(inventario)) return;

    const realData = inventario.filter(item => item && item.message !== 'empty_array');
    if (realData.length === 0) return;

    const setup = setUpTable(type);
    const headers = [...setup.headers];
    let keys = [];

    if (type === 'sell') keys = ['sku', 'name', 'value'];
    else if (type === 'buy') keys = ['sku', 'name', 'buy_value'];
    else if (type === 'stock') keys = ['sku', 'name', 'value', 'buy_value', 'stock', 'warranty', 'has_tax', 'enable'];

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Productos');

    // Add styled header
    const headerRow = worksheet.addRow(headers);
    headerRow.eachCell((cell) => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF1A73E8' }
        };
        cell.font = { color: { argb: 'FFFFFFFF' }, bold: true };
        cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    realData.forEach(item => {
        const rowValues = keys.map(key => {
            let val = item[key];
            if (key === 'enable' || key === 'has_tax') return val ? 'Si' : 'No';
            if (key === 'value' || key === 'buy_value') return typeof val === 'number' ? val : parseFloat(val) || 0;
            return val;
        });
        worksheet.addRow(rowValues);
    });

    worksheet.columns.forEach(column => { column.width = 20; });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const fileName = `productos_${type}_${new Date().toISOString().split('T')[0]}.xlsx`;

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
}
